/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDocumentDto } from '../../models/create-document-dto';
import { ResponseDocumentDto } from '../../models/response-document-dto';

export interface DocumentsControllerCreateDocument$Params {
      body: CreateDocumentDto
}

export function documentsControllerCreateDocument(http: HttpClient, rootUrl: string, params: DocumentsControllerCreateDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerCreateDocument.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseDocumentDto>;
    })
  );
}

documentsControllerCreateDocument.PATH = '/thalea-documents/documents';
